{
  "steplist": "Darbību saraksts"
}
